import { Menu, Dropdown, Checkbox, Button, Divider } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useState, forwardRef, useImperativeHandle } from 'react';
import { useRouterTarget } from '&/utils/customHooks';

import './index.scss';

const PhotoAlbumBar = forwardRef((props, ref) => {
    const {
        total = '',
        resolution = [],
        space = [],
        typeList = [],
        isVrRoom = false,
        isPhoto = false,
        onParamsChange = () => {},
        onTypeChange = () => {},
        onAllSelectChange = () => {},
        onDelete = () => {},
        onDownload = () => {},
    } = props;

    const targetPage = useRouterTarget();

    const [resolutionItem, setResolutionItem] = useState(resolution[0]);
    const [spaceItem, setSpaceItem] = useState(space[0]);
    const [typeItem, setTypeItem] = useState(typeList[0]);

    const onResolutionClick = ({ item, key }) => {
        console.log('resolution111', resolution);
        console.log('key', key);
        const selected = resolution.find(item => item.id === key);
        console.log('selected', selected);
        setResolutionItem(selected);
        onParamsChange(key, spaceItem?.id);
        setSelectedAll(false);
        setIsShowOperateBtn(false);
    };
    const onSpaceClick = ({ item, key }) => {
        const selected = space.find(item => item.id === key);
        setSpaceItem(selected);
        onParamsChange(resolutionItem?.id, key);
        setSelectedAll(false);
        setIsShowOperateBtn(false);
    };
    const onTypeClick = ({ item, key }) => {
        const selected = typeList.find(item => +item.id === +key);
        setTypeItem(selected);
        onTypeChange(selected);
    };

    const resolutionMenu = (
        <Menu
            onClick={onResolutionClick}
            defaultSelectedKeys={'0'}
            selectedKeys={resolutionItem?.id}>
            {resolution.map(item => (
                <Menu.Item key={item.id}>{item.name}</Menu.Item>
            ))}
        </Menu>
    );

    const spaceMenu = (
        <Menu onClick={onSpaceClick} selectedKeys={spaceItem?.id}>
            {space.map(item => (
                <Menu.Item key={item.id}>{item.name}</Menu.Item>
            ))}
        </Menu>
    );

    const typeMenu = (
        <Menu onClick={onTypeClick} selectedKeys={typeItem?.id}>
            {typeList.map(item => (
                <Menu.Item key={item.id}>{item.name}</Menu.Item>
            ))}
        </Menu>
    );

    const [isShowOperateBtn, setIsShowOperateBtn] = useState(false);
    const [selectedAll, setSelectedAll] = useState(false);

    const onChange = e => {
        console.log(`checked = ${e.target.checked}`);
        if (e.target.checked) {
            setIsShowOperateBtn(true);
        } else {
            setIsShowOperateBtn(false);
        }
        setSelectedAll(e.target.checked);
        onAllSelectChange(e.target.checked);
    };

    useImperativeHandle(ref, () => {
        // 需要将暴露的接口返回出去
        return {
            setIsShowOperateBtn: setIsShowOperateBtn,
            setSelectedAll: setSelectedAll,
            spaceItem,
            resolutionItem,
        };
    });

    const onCreateVrRoom = () => {
        console.log('创建全屋漫游图');
        targetPage({
            pathname: '/hdd/virtualHouseCerate',
            search: { schemeId: props.schemeId },
        });
    };

    return (
        <div className="photo-album-bar">
            <div className="header-title">
                <div className="total">
                    <span>
                        共{total}张
                        {isPhoto
                            ? '普通图'
                            : isVrRoom
                            ? '全屋漫游图'
                            : '全景图'}
                    </span>
                    {isVrRoom && (
                        <Button
                            className="create-vr-room"
                            type="primary"
                            onClick={onCreateVrRoom}>
                            创建全屋漫游图
                        </Button>
                    )}
                </div>
                <div className="right-operate">
                    {!isVrRoom && (
                        <Dropdown
                            overlay={resolutionMenu}
                            overlayClassName="hdd-dropdown-menu"
                            trigger={['click']}>
                            <span className="resolution">
                                {resolutionItem?.name}
                                <DownOutlined />
                            </span>
                        </Dropdown>
                    )}
                    {!isVrRoom && (
                        <Dropdown
                            overlay={spaceMenu}
                            overlayClassName="hdd-dropdown-menu"
                            trigger={['click']}>
                            <span className="space">
                                {spaceItem.name}
                                <DownOutlined />
                            </span>
                        </Dropdown>
                    )}
                    {!isVrRoom && <Divider type="vertical" />}
                    {isVrRoom && false && (
                        <Dropdown
                            overlay={typeMenu}
                            overlayClassName="hdd-dropdown-menu"
                            trigger={['click']}>
                            <span className="space">
                                {typeItem.name}
                                <DownOutlined />
                            </span>
                        </Dropdown>
                    )}
                    <Checkbox onChange={onChange} checked={selectedAll}>
                        全选
                    </Checkbox>
                    {isShowOperateBtn && (
                        <Button className="delete" onClick={onDelete}>
                            删除
                        </Button>
                    )}
                    {isPhoto && isShowOperateBtn && (
                        <Button className="download" onClick={onDownload}>
                            下载
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
});

export default PhotoAlbumBar;
